import React from 'react'
import styles from './testimonial.module.scss'
import { ERCText } from 'components/text'

const TestimonialCard = ({ name, occupation, note }) => {
    return (
        <div className={styles.body} >
            <div className={styles.quote} >
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <rect x="24" width="33.9411" height="33.9411" rx="6.71436" transform="rotate(45 24 0)" fill="#FFD600" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7374 16.9648C20.3003 16.9648 19.1747 17.3618 18.3918 18.1448C17.6089 18.9277 17.2119 20.0533 17.2119 21.4903V30.5413H22.8688V21.4903H19.4747C19.4747 20.6752 19.6487 20.0879 19.9918 19.7447C20.335 19.4016 20.9222 19.2276 21.7374 19.2276" fill="#00296B" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.6573 16.9648C28.2203 16.9648 27.0947 17.3618 26.3117 18.1448C25.5288 18.9277 25.1318 20.0533 25.1318 21.4903V30.5413H30.7887V21.4903H27.3946C27.3946 20.6752 27.5686 20.0879 27.9117 19.7447C28.2549 19.4016 28.8422 19.2276 29.6573 19.2276" fill="#00296B" />
                </svg>
            </div>
            <div className={styles.container} >

                <ERCText size='16px' weight='400' lHeight='24px' align='justify' color='#3D3D3D' >{note}</ERCText>


                <div className={styles.details} >
                    <ERCText align='justify' size='14px' weight='700' lHeight='20px' >{name}</ERCText>
                    <ERCText size='14px' lHeight='20px' weight='400' align='justify' color='#525252' >{occupation}</ERCText>
                </div>

            </div>
        </div>
    )
}

export default TestimonialCard